
 import React, { useState, useEffect, useRef } from "react";
//  import wrapImage from './food.avif';
 import { useNavigate } from "react-router-dom";
 import { useParams } from "react-router-dom";
 import { FaEye, FaEyeSlash, FaMapMarkerAlt, FaSearch, FaBars, FaTimes } from "react-icons/fa";
 import { useSearchParams } from "react-router-dom";
 
 import NotificationsIcon from "@mui/icons-material/Notifications";
 import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
 import AccountCircleIcon from "@mui/icons-material/AccountCircle";
 import { Paper, MenuItem, IconButton, Badge, Slide } from "@mui/material";
 
 import LogoutIcon from "@mui/icons-material/Logout";
 import PersonIcon from "@mui/icons-material/Person";
 import axios from "axios";
  // import { useNavigate } from "react-router-dom";
  // import Mapintigration from './Mapintigration';
 
 import SliderComponent from './SliderComponent';
 
 const NavBars = ({ showLogin, setShowLogin }) => {
   const [index, setIndex] = useState(0);
   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
   const [scrolled, setScrolled] = useState(false);
   const [showMobileMenu, setShowMobileMenu] = useState(false);
   const [showPopup, setShowPopup] = useState(false);
   const [showForgetPassword, setShowForgetPassword] = useState(false);
   const [isForgot, setIsForgot] = useState(false);
   const [loginObj, setLoginObj] = useState({
     userName: "",
     password: "",
   });
   const [showPassword, setShowPassword] = useState(false);
   const [hidePassword, setHidePassword] = useState(true);
   const [isLoading, setIsLoading] = useState(false);
   const [error, setError] = useState("");
   const navigate = useNavigate();
   const [showPasswordFields, setShowPasswordFields] = useState(false);
   const [forgotEmail, setForgotEmail] = useState("");
   const [email, setEmail] = useState("");
   const [message, setMessage] = useState("");
   const [isSignup, setIsSignup] = useState(false);
   const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
   const [loginStepStarted, setLoginStepStarted] = useState(false);
   const [emailCheckMessage, setEmailCheckMessage] = useState("");
   const [loading, setLoading] = useState(false);
   const [cartCount, setCartCount] = useState(0);
   const [signupType, setSignupType] = useState("personal");
   const [termsAccepted, setTermsAccepted] = useState(false);
   const [showContainer, setShowContainer] = useState(false);
 
   // Location States
   const [showLocationPopup, setShowLocationPopup] = useState(false);
   const [selectedAddress, setSelectedAddress] = useState(null);
   const [savedAddresses, setSavedAddresses] = useState([
    //  {
    //    title: "Home",
    //    full: "123 Main Street, Apartment 4B, New York, NY 10001",
    //    lat: 40.7128,
    //    lng: -74.0060
    //  },
    //  {
    //    title: "Work",
    //    full: "456 Business Ave, Floor 12, New York, NY 10017",
    //    lat: 40.7527,
    //    lng: -73.9772
    //  }
   ]);
   const [searchQuery, setSearchQuery] = useState("");
   const [isLocating, setIsLocating] = useState(false);
   const [locationError, setLocationError] = useState("");
 
   // Map States
   const [showMapPopup, setShowMapPopup] = useState(false);
   const [mapSelectedLocation, setMapSelectedLocation] = useState(null);
   const [mapAddress, setMapAddress] = useState("");
   const [addressTitle, setAddressTitle] = useState("");
   const [isMapLoading, setIsMapLoading] = useState(false);
   const mapRef = useRef(null);
 
   const [drawerOpen, setDrawerOpen] = useState(false);
 
   // Mobile specific states
   const [showMobileSearch, setShowMobileSearch] = useState(false);
   const [selectedCity, setSelectedCity] = useState("");
   const [area, setArea] = useState("");
   const [pincode, setPincode] = useState("");
 
   const [isLoggedIn, setIsLoggedIn] = useState(false);
 
   useEffect(() => {
     const loggedIn = localStorage.getItem("isLoggedIn") === "true";
     setIsLoggedIn(loggedIn);
     
     // Fetch cart count
     const count = JSON.parse(localStorage.getItem("cartItems") || "[]").length;
     setCartCount(count);
     
     // Fetch user saved location if logged in
     if (loggedIn) {
       fetchUserSavedLocation();
     }
   }, []);
 
   useEffect(() => {
     if (showLocationPopup) {
       fetchUserSavedLocation();
     }
   }, [showLocationPopup]);
 
   // Initialize Map when popup opens
   useEffect(() => {
     if (showMapPopup) {
       if (!document.querySelector('link[href*="leaflet"]')) {
         const link = document.createElement('link');
         link.rel = 'stylesheet';
         link.href = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css';
         document.head.appendChild(link);
       }
 
       if (!window.L) {
         const script = document.createElement('script');
         script.src = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js';
         script.onload = initializeMap;
         document.head.appendChild(script);
       } else {
         initializeMap();
       }
     }
   }, [showMapPopup]);
 
   const initializeMap = () => {
     if (!mapRef.current || !window.L) return;
 
     if (window.currentMap) {
       window.currentMap.remove();
     }
 
     const defaultLocation = [40.7128, -74.0060];
     const map = window.L.map(mapRef.current).setView(defaultLocation, 13);
     window.currentMap = map;
 
     window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
       attribution: '© OpenStreetMap contributors'
     }).addTo(map);
 
     map.on('click', (e) => {
       const clickedLocation = [e.latlng.lat, e.latlng.lng];
       setMapSelectedLocation(clickedLocation);
       updateMarker(clickedLocation, map);
       getAddressFromCoordinates(clickedLocation);
     });
 
     if (navigator.geolocation) {
       navigator.geolocation.getCurrentPosition(
         (position) => {
           const userLocation = [position.coords.latitude, position.coords.longitude];
           map.setView(userLocation, 15);
           setMapSelectedLocation(userLocation);
           updateMarker(userLocation, map);
           getAddressFromCoordinates(userLocation);
         },
         () => {
           setMapSelectedLocation(defaultLocation);
           updateMarker(defaultLocation, map);
           getAddressFromCoordinates(defaultLocation);
         }
       );
     }
   };
 
   const updateMarker = (location, map) => {
     if (window.currentMarker) {
       window.currentMarker.remove();
     }
 
     const marker = window.L.marker(location, { draggable: true }).addTo(map);
     window.currentMarker = marker;
 
     marker.on('dragend', (e) => {
       const draggedLocation = [e.target.getLatLng().lat, e.target.getLatLng().lng];
       setMapSelectedLocation(draggedLocation);
       getAddressFromCoordinates(draggedLocation);
     });
   };
 
   const getAddressFromCoordinates = async (location) => {
     setIsMapLoading(true);
     try {
       const response = await fetch(
         `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location[0]},${location[1]}&key=`
       );
       const data = await response.json();
 
       if (data.status === "OK" && data.results.length > 0) {
         setMapAddress(data.results[0].formatted_address);
       } else {
         setMapAddress("Address not found");
       }
     } catch (error) {
       console.error("Error getting address:", error);
       setMapAddress("Error getting address");
     } finally {
       setIsMapLoading(false);
     }
   };
 
   const handleSaveAddressFromMap = async () => {
     if (!mapSelectedLocation || !mapAddress) return;
 
     const title = addressTitle || "Custom Location";
     const newAddress = {
       title,
       full: mapAddress,
       lat: mapSelectedLocation[0],
       lng: mapSelectedLocation[1]
     };
 
     setSavedAddresses(prev => [newAddress, ...prev]);
     setSelectedAddress(mapAddress);
 
     try {
       const token = localStorage.getItem("authToken");
       const userId = localStorage.getItem("userId");
 
       if (!userId || !token) throw new Error("User not logged in");
 
       const res = await fetch(
         `https://backend.maamaas.com/subscription/api/user/curret/location/update`,
         {
           method: "POST",
           headers: {
             "Content-Type": "application/json",
             Authorization: `Bearer ${token}`,
           },
           body: JSON.stringify({
             userId,
             lat: mapSelectedLocation[0],
             lng: mapSelectedLocation[1],
             address: mapAddress,
           }),
         }
       );
 
       const result = await res.json();
       console.log("Location updated:", result);
     } catch (error) {
       console.error("Error updating location:", error);
     }
 
     setShowMapPopup(false);
     setShowLocationPopup(false);
     setAddressTitle("");
     setMapSelectedLocation(null);
     setMapAddress("");
 
     if (window.currentMap) window.currentMap.remove();
     window.currentMap = null;
     window.currentMarker = null;
   };
 
   const getCurrentLocation = () => {
     setIsLocating(true);
     setLocationError("");
 
     if (!navigator.geolocation) {
       setLocationError("Geolocation is not supported by this browser.");
       setIsLocating(false);
       return;
     }
 
     navigator.geolocation.getCurrentPosition(
       async (position) => {
         const { latitude, longitude } = position.coords;
 
         try {
           const googleRes = await fetch(
             `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=`
           );
           const googleData = await googleRes.json();
           const fullAddress = googleData?.results?.[0]?.formatted_address || "";
 
           setSelectedAddress(fullAddress);
 
           const isAlreadySaved = savedAddresses.some(
             addr => addr.title === "Current Location"
           );
 
           if (!isAlreadySaved) {
             setSavedAddresses(prev => [
               {
                 title: "Current Location",
                 full: fullAddress,
                 lat: latitude,
                 lng: longitude
               },
               ...prev
             ]);
           }
 
           const token = localStorage.getItem("authToken");
           const backendRes = await fetch(
             `https://backend.maamaas.com/subscription/api/user/get/current/location/1`,
             {
               headers: {
                 Authorization: `Bearer ${token}`,
               },
             }
           );
           const backendData = await backendRes.json();
           console.log("Current location from backend:", backendData);
 
           if (backendData?.address) {
             setSelectedAddress(backendData.address);
           }
 
           setShowLocationPopup(false);
         } catch (error) {
           console.error("Error getting current location:", error);
           setLocationError("Error retrieving address. Please try again.");
         } finally {
           setIsLocating(false);
         }
       },
       (error) => {
         console.error("Error getting location:", error);
         let errorMessage = "Unable to retrieve your location. ";
         switch (error.code) {
           case error.PERMISSION_DENIED:
             errorMessage += "Please enable location permissions in your browser settings.";
             break;
           case error.POSITION_UNAVAILABLE:
             errorMessage += "Location information is unavailable.";
             break;
           case error.TIMEOUT:
             errorMessage += "Location request timed out.";
             break;
           default:
             errorMessage += "An unknown error occurred.";
             break;
         }
         setLocationError(errorMessage);
         setIsLocating(false);
       },
       {
         enableHighAccuracy: true,
         timeout: 10000,
         maximumAge: 60000
       }
     );
   };
 
   const fetchUserSavedLocation = async () => {
     try {
       const token = localStorage.getItem("authToken");
       const userId = localStorage.getItem("userId");
       if (!userId || !token) return;
 
       const res = await fetch(
         `https://backend.maamaas.com/subscription/api/user/get/current/location/${userId}`,
         {
           headers: {
             "Content-Type": "application/json",
             Authorization: `Bearer ${token}`,
           },
         }
       );
 
       const data = await res.json();
       console.log("🔹 User saved backend location:", data);
 
       if (data?.address) {
         setSelectedAddress(data.address);
         setSavedAddresses(prev => [
           {
             title: "Saved Location",
             full: data.address,
             lat: data.lat,
             lng: data.lng
           },
           ...prev
         ]);
       }
     } catch (error) {
       console.error("❌ Error fetching saved location:", error);
     }
   };
 
   const handleAddressSearch = async () => {
     if (!searchQuery.trim()) return;
 
     try {
       const response = await fetch(
         `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}&limit=5`
       );
 
       const data = await response.json();
 
       if (data && data.length > 0) {
         const result = data[0];
         const address = result.display_name;
 
         setSelectedAddress(address);
 
         setSavedAddresses(prev => [
           {
             title: "Searched Location",
             full: address,
             lat: parseFloat(result.lat),
             lng: parseFloat(result.lon)
           },
           ...prev
         ]);
 
         setShowLocationPopup(false);
         setSearchQuery("");
       } else {
         setLocationError("No addresses found for your search.");
       }
     } catch (error) {
       console.error("Error searching address:", error);
       setLocationError("Error searching for address. Please try again.");
     }
   };
 
   function handleSignInClick() {
     setShowLogin(true);
   }
 
   const handleProfile = () => {
     console.log("Profile button clicked");
     navigate("/profilepage");
   };
 
   useEffect(() => {
     let timer;
     if (showContainer) {
       timer = setTimeout(() => {
         setShowContainer(false);
       }, 3000);
     }
     return () => clearTimeout(timer);
   }, [showContainer]);
 
   const handleNavigate = () => {
     navigate("/cartsdata");
   };
 
   const handleLogout = () => {
     localStorage.removeItem("isLoggedIn");
     localStorage.removeItem("authToken");
     localStorage.removeItem("vendorId");
     setIsLoggedIn(false);
     setShowContainer(false);
     console.log("✅ Logged out successfully");
     navigate("/");
   };
 
   const handleChange = (e) => {
     setLoginObj({ ...loginObj, [e.target.name]: e.target.value });
   };
 
   const handleLogin = async (e) => {
     e.preventDefault();
     setIsLoading(true);
     setError("");
 
     try {
       const url = `https://backend.maamaas.com/subscription/api/auth/login/user?identifier=${encodeURIComponent(
         loginObj.identifier
       )}&password=${encodeURIComponent(loginObj.password)}`;
 
       const response = await fetch(url, {
         method: "POST",
         headers: {
           accept: "*/*",
         },
       });
 
       const text = await response.text();
       let data;
       try {
         data = JSON.parse(text);
       } catch {
         console.error("❌ Server did not return JSON:", text);
         throw new Error("Invalid JSON response from server");
       }
 
       console.log("🔹 Login API Response:", data);
 
       if (response.ok && data.token) {
         localStorage.setItem("authToken", data.token);
         localStorage.setItem("refreshToken", data.refreshToken);
         localStorage.setItem("userId", data.userId);
         localStorage.setItem("userType", data.userType || "");
         localStorage.setItem("professionalUserId", data.professionalUserId);
         localStorage.setItem("role", data.role);
         localStorage.setItem("isLoggedIn", "true");
 
         alert("Login successful!");
         setIsLoggedIn(true);
         setShowLogin(false);
         navigate("/");
       } else {
         setError(data.message || "Login failed. Please try again.");
       }
     } catch (error) {
       console.error("❌ Login error:", error);
       setError("Email or Password wrong. Please try again later.");
     } finally {
       setIsLoading(false);
     }
   };
 
   useEffect(() => {
     const handleResize = () => {
       setIsMobile(window.innerWidth <= 768);
       if (window.innerWidth > 768) {
         setShowMobileMenu(false);
         setShowMobileSearch(false);
       }
     };
 
     const handleScroll = () => setScrolled(window.scrollY > 50);
 
     window.addEventListener("resize", handleResize);
     window.addEventListener("scroll", handleScroll);
 
     return () => {
       window.removeEventListener("resize", handleResize);
       window.removeEventListener("scroll", handleScroll);
     };
   }, []);
 
   const togglePopup = () => {
     setShowPopup(!showPopup);
   };
 
   const toggleMobileMenu = () => {
     setShowMobileMenu(!showMobileMenu);
     setShowMobileSearch(false);
   };
 
   const toggleMobileSearch = () => {
     setShowMobileSearch(!showMobileSearch);
     setShowMobileMenu(false);
   };
 
   const getColoredText = (text) => {
     const words = text.split(" ");
     const half = Math.ceil(words.length / 2);
     return (
       <>
         <span style={{ color: "#FFD700" }}>{words.slice(0, half).join(" ")} </span>
         <span style={{ color: "white" }}>{words.slice(half).join(" ")}</span>
       </>
     );
   };
 
   const handleEmailChange = (e) => {
     setEmail(e.target.value);
   };
 
   const handleSubmit = async (e) => {
     e.preventDefault();
     setLoading(true);
     setMessage("");
     try {
       const response = await axios.post(
         "https://backend.maamaas.com/subscription/api/user/forget/password",
         {
           identifier: email,
         }
       );
 
       if (response.status === 200) {
         setMessage("Reset link sent successfully to your email.");
         setIsEmailSubmitted(true);
       } else {
         setMessage("Something went wrong. Please try again.");
       }
     } catch (error) {
       setMessage(
         error.response?.data?.message ||
         "Error while sending reset link. Please try again."
       );
     } finally {
       setLoading(false);
     }
   };
 
   const handleLogoClick = () => {
     navigate("/");
   };
 
   const styles = {
     section: {
       fontFamily: "Arial, sans-serif",
       backgroundColor: "#ee6521",
     },
     navbar: {
       position: "fixed",
       top: 0,
       left: 0,
       width: "100%",
       display: "flex",
       justifyContent: "space-between",
       alignItems: "center",
       padding: isMobile ? "8px 15px" : "8px 20px",
       backgroundColor: "#ee6521",
       zIndex: 1000,
       boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
     },
     logo: {
       fontSize: isMobile ? "24px" : "30px",
       fontWeight: "bold",
       fontFamily: "roboto",
       color: "white",
       cursor: 'pointer',
       marginRight: isMobile ? "auto" : "20px",
       flexShrink: 0,
     },
     // Mobile Icons Container (for cart, profile when logged in)
     mobileIconsContainer: {
       display: isMobile && isLoggedIn ? "flex" : "none",
       alignItems: "center",
       // gap: "15px",
       marginLeft: "auto",
       marginRight: "10px",
     },
     // Desktop Navigation Buttons
     navButtons: {
       display: isMobile ? "none" : "flex",
       alignItems: "center",
       gap: "15px",
     },
     // Mobile Menu Dropdown (for Partners and Login/Signup when not logged in)
     mobileMenuButtons: {
       display: isMobile && showMobileMenu ? "flex" : "none",
       flexDirection: "column",
       position: "absolute",
       top: "60px",
       right: "10px",
       backgroundColor: "white",
       borderRadius: "8px",
       boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
       padding: "15px",
       zIndex: 1001,
       width: "180px",
     },
     navButton: {
       backgroundColor: "transparent",
       color: isMobile ? "black" : "white",
       fontSize: isMobile ? "14px" : "16px",
       fontWeight: "bold",
       border: "none",
       cursor: "pointer",
       padding: isMobile ? "10px 12px" : "8px 12px",
       borderRadius: "5px",
       transition: "all 0.3s ease",
       textAlign: "left",
       width: "100%",
     },
     signInButton: {
       backgroundColor: "#2a0947",
       color: "white",
       fontSize: isMobile ? "14px" : "16px",
       fontFamily: "Lato, sans-serif",
       fontWeight: "bold",
       borderRadius: "16px",
       width: isMobile ? "100%" : "90px",
       height: isMobile ? "36px" : "40px",
       border: "none",
       cursor: "pointer",
       marginTop: "10px",
     },
     mobileMenuButton: {
       backgroundColor: "transparent",
       border: "none",
       color: "white",
       fontSize: "24px",
       cursor: "pointer",
       display: isMobile ? "block" : "none",
       marginLeft: "10px",
     },
     mobileSearchButton: {
       backgroundColor: "transparent",
       border: "none",
       color: "white",
       fontSize: "20px",
       cursor: "pointer",
       display: isMobile ? "block" : "none",
       marginLeft: "10px",
     },
     locationWrapper: {
       display: isMobile ? "none" : "flex",
       alignItems: "center",
       gap: "15px",
       flex: 1,
       maxWidth: "600px",
       marginLeft: "40px",
       marginRight: "20px",
     },
     mobileLocationWrapper: {
       display: isMobile ? "flex" : "none",
       alignItems: "center",
       gap: "10px",
       marginLeft: "auto",
     },
     locationBox: {
       display: "flex",
       alignItems: "center",
       background: "white",
       color: "#333",
       padding: "8px 16px",
       borderRadius: "20px",
       cursor: "pointer",
       gap: "8px",
       boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
       transition: "all 0.3s ease",
       minWidth: "220px",
       flexShrink: 0,
     },
     mobileLocationIcon: {
       display: "flex",
       alignItems: "center",
       color: "#333",
       padding: "8px",
       borderRadius: "50%",
       cursor: "pointer",
       transition: "all 0.3s ease",
       // background: "rgba(255, 255, 255, 0.2)",
     },
     locationIcon: {
       fontSize: "18px",
       color: "#ff0054"
     },
     locationText: {
       fontWeight: 600,
       fontSize: "14px",
       whiteSpace: "nowrap",
       overflow: "hidden",
       textOverflow: "ellipsis",
       maxWidth: "150px"
     },
     downArrow: {
       fontSize: "12px",
       marginLeft: "5px",
       color: "#666"
     },
     searchInput: {
       padding: "10px 16px",
       borderRadius: "20px",
       border: "1px solid #ddd",
       width: "260px",
       fontSize: "14px",
       outline: "none",
       boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
     },
     mobileSearchContainer: {
       position: "fixed",
       top: "60px",
       left: 0,
       width: "100%",
       backgroundColor: "white",
       padding: "15px",
       boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
       zIndex: 999,
       display: isMobile && showMobileSearch ? "flex" : "none",
       alignItems: "center",
       gap: "10px",
     },
     mobileSearchInput: {
       flex: 1,
       padding: "12px 16px",
       borderRadius: "20px",
       border: "1px solid #ddd",
       fontSize: "16px",
       outline: "none",
     },
     locationPopupOverlay: {
       position: "fixed",
       top: 0,
       left: 0,
       width: "100%",
       height: "100%",
       background: "rgba(0,0,0,0.5)",
       display: "flex",
       justifyContent: "center",
       alignItems: "center",
       zIndex: 9999,
     },
     locationPopup: {
       background: "white",
       width: isMobile ? "95%" : "450px",
       borderRadius: "20px",
       padding: "20px",
       maxHeight: "85vh",
       overflowY: "auto",
       boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
     },
     popupHeader: {
       display: "flex",
       justifyContent: "space-between",
       alignItems: "center",
       marginBottom: "15px",
       paddingBottom: "15px",
       borderBottom: "1px solid #eee",
     },
     popupTitle: {
       margin: 0,
       fontSize: "20px",
       fontWeight: "700",
       color: "#333",
     },
     closePopupBtn: {
       cursor: "pointer",
       fontSize: "20px",
       color: "#666",
       background: "none",
       border: "none",
     },
     searchContainer: {
       display: "flex",
       alignItems: "center",
       background: "#f7f7f7",
       borderRadius: "12px",
       padding: "12px 15px",
       marginBottom: "20px",
     },
     searchIcon: {
       marginRight: "10px",
       color: "#666",
       fontSize: "18px"
     },
     popupSearchInput: {
       border: "none",
       outline: "none",
       width: "100%",
       background: "transparent",
       fontSize: "16px",
     },
     optionBox: {
       display: "flex",
       justifyContent: "space-between",
       alignItems: "center",
       background: "white",
       borderRadius: "15px",
       padding: "18px",
       border: "1px solid #eee",
       marginBottom: "15px",
       boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
       cursor: "pointer",
       transition: "all 0.3s ease",
     },
     optionContent: {
       display: "flex",
       alignItems: "center",
       gap: "12px",
     },
     optionTitle: {
       color: "#333",
       margin: 0,
       fontSize: "16px",
       fontWeight: "600"
     },
     optionDesc: {
       color: "#666",
       margin: "5px 0 0 0",
       fontSize: "14px"
     },
     enableBtn: {
       border: "1px solid #ff0054",
       background: "white",
       color: "#ff0054",
       padding: "8px 16px",
       borderRadius: "20px",
       cursor: "pointer",
       fontWeight: "600",
       fontSize: "14px",
       transition: "all 0.3s ease",
     },
     addAddressBox: {
       display: "flex",
       alignItems: "center",
       gap: "12px",
       padding: "18px",
       background: "white",
       borderRadius: "15px",
       border: "1px solid #eee",
       cursor: "pointer",
       marginBottom: "20px",
       boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
       transition: "all 0.3s ease",
     },
     plusIcon: {
       fontSize: "20px",
       color: "#ff0054",
     },
     addAddressText: {
       color: "#ff0054",
       fontSize: "16px",
       fontWeight: "600",
     },
     savedHeading: {
       marginTop: "25px",
       marginBottom: "15px",
       fontSize: "18px",
       fontWeight: "600",
       color: "#333",
     },
     savedBox: {
       display: "flex",
       gap: "15px",
       padding: "16px",
       borderRadius: "15px",
       background: "white",
       border: "1px solid #eee",
       marginBottom: "12px",
       cursor: "pointer",
       transition: "all 0.3s ease",
       boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
     },
     savedTitle: {
       margin: 0,
       fontSize: "16px",
       fontWeight: "600",
       color: "#333"
     },
     savedAddressText: {
       margin: "5px 0 0 0",
       fontSize: "14px",
       color: "#666",
       lineHeight: "1.4"
     },
     loadingSpinner: {
       display: "inline-block",
       width: "20px",
       height: "20px",
       border: "3px solid rgba(255,0,84,0.3)",
       borderRadius: "50%",
       borderTopColor: "#ff0054",
       animation: "spin 1s ease-in-out infinite",
       marginRight: "10px",
     },
     errorMessage: {
       color: "#ff0054",
       fontSize: "14px",
       textAlign: "center",
       margin: "10px 0",
       padding: "10px",
       backgroundColor: "#fff5f5",
       borderRadius: "8px",
     },
   };
 
   return (
     <div style={styles.section}>
       {/* Fixed Navbar */}
       <div style={styles.navbar}>
         {/* Logo */}
         <div style={styles.logo} onClick={handleLogoClick}>
           MAAMAA'S
         </div>
 
         {/* Desktop: Select Location + Search Box */}
         <div style={styles.locationWrapper}>
           <div
             style={styles.locationBox}
             onClick={() => setShowLocationPopup(true)}
             onMouseEnter={(e) => {
               e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.2)";
               e.currentTarget.style.transform = "translateY(-2px)";
               e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.25)";
             }}
             onMouseLeave={(e) => {
               e.currentTarget.style.boxShadow = "0 2px 5px rgba(0,0,0,0.1)";
               e.currentTarget.style.transform = "translateY(0)";
               e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
             }}
           >
             <span style={styles.locationIcon}>
               <FaMapMarkerAlt />
             </span>
             <span style={styles.locationText}>
               {selectedAddress ?
                 (selectedAddress.length > 25 ? selectedAddress.substring(0, 25) + '...' : selectedAddress)
                 : "Select Location"
               }
             </span>
             <span style={styles.downArrow}>▾</span>
           </div>
 
           {/* <input
       type="text"
       placeholder="Search for items"
       style={styles.searchInput}
       value={searchQuery}
       onChange={(e) => setSearchQuery(e.target.value)}
     /> */}
         </div>
 
         {/* Mobile View */}
         {isMobile && (
           <>
             {/* Mobile Icons Container (Cart, Profile) - Only when logged in */}
             {isLoggedIn && (
               <div style={styles.mobileIconsContainer}>
 
                 <div style={styles.mobileLocationWrapper}>
               <div
                 style={styles.mobileLocationIcon}
                 onClick={() => setShowLocationPopup(true)}
               >
                 <span style={styles.locationIcon}>
                   <FaMapMarkerAlt />
                 </span>
               </div>
 
               {/* <button
                 style={styles.mobileSearchButton}
                 onClick={toggleMobileSearch}
               >
                 <FaSearch />
               </button> */}
 
               {/* <button
                 style={styles.mobileMenuButton}
                 onClick={toggleMobileMenu}
               >
                 {showMobileMenu ? <FaTimes /> : <FaBars />}
               </button> */}
             </div>
                 <IconButton 
                   sx={{ 
                     color: "white",
                     padding: "6px"
                   }} 
                   onClick={handleNavigate}
                 >
                   <Badge
                     badgeContent={cartCount}
                     color="error"
                     invisible={cartCount === 0}
                     sx={{
                       "& .MuiBadge-badge": {
                         backgroundColor: "red",
                         color: "white",
                         borderRadius: "4px",
                         padding: "0 6px",
                         minWidth: "20px",
                         height: "20px",
                         fontSize: "12px",
                       },
                     }}
                   >
                     <ShoppingCartIcon fontSize="medium" />
                   </Badge>
                 </IconButton>
 
                 <IconButton
                   onClick={() => setShowContainer(!showContainer)}
                   sx={{ 
                     color: "white",
                     padding: "6px"
                   }}
                 >
                   <AccountCircleIcon fontSize="medium" />
                 </IconButton>
               </div>
             )}
 
             {/* Mobile Location and Menu Icons */}
             
 
             {/* Mobile Dropdown Menu (For Partners and Login/Signup when NOT logged in) */}
             {showMobileMenu && !isLoggedIn && (
               <div style={styles.mobileMenuButtons}>
                 <a
                   href="https://partners.maamaas.com/"
                   target="_blank"
                   rel="noopener noreferrer"
                   style={{
                     ...styles.navButton,
                     color: "black",
                     textDecoration: "none",
                     display: "block",
                     textAlign: "center",
                     padding: "10px",
                     backgroundColor: "#f5f5f5",
                     borderRadius: "5px",
                   }}
                 >
                   PARTNERS
                 </a>
                 <SliderComponent setShowLogin={setShowLogin} />
               </div>
             )}
           </>
         )}
 
         {/* Desktop View Navigation Buttons */}
         {!isMobile && (
           <div style={styles.navButtons}>
             {isLoggedIn ? (
               <>
                 <IconButton sx={{ color: "white" }}>
                   {/* <NotificationsIcon fontSize="large" /> */}
                 </IconButton>
 
                 <IconButton sx={{ color: "white" }} onClick={handleNavigate}>
                   <Badge
                     badgeContent={cartCount}
                     color="error"
                     invisible={cartCount === 0}
                     sx={{
                       "& .MuiBadge-badge": {
                         backgroundColor: "red",
                         color: "white",
                         borderRadius: "4px",
                         padding: "0 6px",
                         minWidth: "20px",
                         height: "20px",
                       },
                     }}
                   >
                     <ShoppingCartIcon fontSize="large" />
                   </Badge>
                 </IconButton>
 
                 <IconButton
                   onClick={() => setShowContainer(!showContainer)}
                   sx={{ color: "white" }}
                 >
                   <AccountCircleIcon fontSize="large" />
                 </IconButton>
               </>
             ) : (
               <>
                 <a
                   href="https://partners.maamaas.com/"
                   target="_blank"
                   rel="noopener noreferrer"
                   style={{
                     color: "white",
                     fontSize: "18px",
                     fontWeight: "bold",
                     fontFamily: "Arial, sans-serif",
                     textDecoration: "none"
                   }}
                 >
                   PARTNERS
                 </a>
                 <SliderComponent setShowLogin={setShowLogin} />
               </>
             )}
           </div>
         )}
 
         {/* Mobile Search Bar */}
         <div style={styles.mobileSearchContainer}>
           <input
             type="text"
             placeholder="Search for items..."
             style={styles.mobileSearchInput}
           />
           <button
             style={styles.closePopupBtn}
             onClick={() => setShowMobileSearch(false)}
           >
             ✕
           </button>
         </div>
       </div>
 
       
       {showContainer && (
         <Slide direction="down" in={true} mountOnEnter unmountOnExit>
           <Paper
             sx={{
               position: "fixed",
               top: isMobile ? "50px" : "60px",
               right: isMobile ? "10px" : "10px",
               width: isMobile ? "140px" : "150px",
               backgroundColor: "white",
               boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
               borderRadius: "10px",
               zIndex: 1000,
               overflow: "hidden",
             }}
           >
             <MenuItem
               onClick={handleProfile}
               sx={{
                 display: "flex",
                 justifyContent: "space-between",
                 alignItems: "center",
                 padding: "10px 14px",
                 fontSize: isMobile ? "14px" : "15px",
                 fontWeight: 500,
                 borderBottom: "1px solid #f0f0f0",
               }}
             >
               Profile
               <PersonIcon fontSize="small" />
             </MenuItem>
 
             <MenuItem
               onClick={handleLogout}
               sx={{
                 display: "flex",
                 justifyContent: "space-between",
                 alignItems: "center",
                 padding: "10px 14px",
                 fontSize: isMobile ? "14px" : "15px",
                 fontWeight: 500,
               }}
             >
               Logout
               <LogoutIcon fontSize="small" />
             </MenuItem>
           </Paper>
         </Slide>
       )}
 
      
       {showLocationPopup && (
         <div style={styles.locationPopupOverlay}>
           <div style={styles.locationPopup}>
             <div style={styles.popupHeader}>
               <h2 style={styles.popupTitle}>Select Your Location</h2>
               <button
                 style={styles.closePopupBtn}
                 onClick={() => {
                   setShowLocationPopup(false);
                   setLocationError("");
                   setSearchQuery("");
                 }}
               >
                 ✕
               </button>
             </div>
 
            
             <div style={styles.searchContainer}>
               <span style={styles.searchIcon}>🔍</span>
               <input
                 type="text"
                 placeholder="Search for area, street name..."
                 style={styles.popupSearchInput}
                 value={searchQuery}
                 onChange={(e) => setSearchQuery(e.target.value)}
                 onKeyPress={(e) => {
                   if (e.key === 'Enter') {
                     handleAddressSearch();
                   }
                 }}
               />
             </div>
 
            
             <div
               style={styles.optionBox}
               onClick={getCurrentLocation}
               onMouseEnter={(e) => {
                 e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                 e.target.style.transform = "translateY(-2px)";
               }}
               onMouseLeave={(e) => {
                 e.target.style.boxShadow = "0 2px 8px rgba(0,0,0,0.05)";
                 e.target.style.transform = "translateY(0)";
               }}
             >
               <div style={styles.optionContent}>
                 <span style={{ display: "inline-flex", alignItems: "center", color: "#FF4D4D", fontSize: "18px" }}>
                   <FaMapMarkerAlt />
                 </span>
                 <div>
                   <h3 style={styles.optionTitle}>Use My Current Location</h3>
                   <p style={styles.optionDesc}>
                     Enable your current location for better services
                   </p>
                 </div>
               </div>
               <button
                 style={styles.enableBtn}
                 disabled={isLocating}
               >
                 {isLocating ? (
                   <>
                     <span style={styles.loadingSpinner}></span>
                     Locating...
                   </>
                 ) : (
                   "Detect"
                 )}
               </button>
             </div>
 
           
             <div
               style={styles.addAddressBox}
               onClick={() => setShowMapPopup(true)}
               onMouseEnter={(e) => {
                 e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                 e.target.style.transform = "translateY(-2px)";
               }}
               onMouseLeave={(e) => {
                 e.target.style.boxShadow = "0 2px 8px rgba(0,0,0,0.05)";
                 e.target.style.transform = "translateY(0)";
               }}
             >
               <span style={styles.plusIcon}>＋</span>
               <span style={styles.addAddressText}>Add New Address on Map</span>
             </div>
 
           
             {locationError && (
               <div style={styles.errorMessage}>
                 {locationError}
               </div>
             )}
 
             
             <h3 style={styles.savedHeading}>Saved Addresses</h3>
 
             {savedAddresses.map((item, index) => (
               <div
                 key={index}
                 style={styles.savedBox}
                 onClick={() => {
                   setSelectedAddress(item.full);
                   setShowLocationPopup(false);
                   setLocationError("");
                 }}
                 onMouseEnter={(e) => {
                   e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                   e.target.style.transform = "translateY(-2px)";
                 }}
                 onMouseLeave={(e) => {
                   e.target.style.boxShadow = "0 2px 5px rgba(0,0,0,0.05)";
                   e.target.style.transform = "translateY(0)";
                 }}
               >
                 <div style={{ display: "inline-flex", alignItems: "center", color: "#666", fontSize: "18px" }}>
                   <FaMapMarkerAlt />
                 </div>
                 <div>
                   <h4 style={styles.savedTitle}>{item.title}</h4>
                   <p style={styles.savedAddressText}>{item.full}</p>
                 </div>
               </div>
             ))}
           </div>
         </div>
       )}
 
      
       {showMapPopup && (
         <div style={{
           position: "fixed",
           top: 0, left: 0,
           width: "100vw",
           height: "100vh",
           backgroundColor: "rgba(0,0,0,0.5)",
           display: "flex",
           justifyContent: "center",
           alignItems: "center",
           zIndex: 9999,
           padding: "20px",
           boxSizing: "border-box",
         }}>
           <div style={{
             width: "100%",
             maxWidth: "700px",
             height: "90%",
             background: "#fff",
             borderRadius: "12px",
             display: "flex",
             flexDirection: "column",
             overflow: "hidden",
             boxShadow: "0 10px 25px rgba(0,0,0,0.25)"
           }}>
             
             <div style={{
               display: "flex",
               justifyContent: "space-between",
               alignItems: "center",
               padding: "12px 16px",
               borderBottom: "1px solid #ddd",
             }}>
               <h2 style={{ margin: 0, fontSize: "18px", fontWeight: 600 }}>Select Location on Map</h2>
               <button
                 style={{
                   background: "transparent",
                   border: "none",
                   fontSize: "20px",
                   cursor: "pointer",
                   lineHeight: 1
                 }}
                 onClick={() => {
                   setShowMapPopup(false);
                   setMapSelectedLocation(null);
                   setMapAddress("");
                   setAddressTitle("");
                   if (window.currentMap) { window.currentMap.remove(); window.currentMap = null; }
                   if (window.currentMarker) { window.currentMarker = null; }
                 }}
               >✕</button>
             </div>
 
             
             <div style={{ flex: 1, position: "relative", display: "flex", flexDirection: "column" }}>
               <div ref={mapRef} style={{
                 flex: 1,
                 width: "100%",
                 minHeight: "300px",
                 background: "#f0f0f0",
                 position: "relative"
               }}>
                 {!window.L && (
                   <div style={{
                     position: "absolute",
                     top: 0, left: 0, right: 0, bottom: 0,
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                     color: "#666",
                     fontSize: "16px"
                   }}>
                     <div style={{
                       width: "24px",
                       height: "24px",
                       border: "3px solid #ccc",
                       borderTop: "3px solid #333",
                       borderRadius: "50%",
                       marginRight: "8px",
                       animation: "spin 1s linear infinite"
                     }}></div>
                     Loading map...
                   </div>
                 )}
               </div>
 
              
               <div style={{
                 padding: "12px 16px",
                 borderTop: "1px solid #ddd",
                 display: "flex",
                 flexDirection: "column",
                 gap: "10px"
               }}>
               
                 <div style={{
                   minHeight: "24px",
                   color: "#333",
                   fontSize: "14px",
                 }}>
                   {isMapLoading
                     ? <span>Getting address...</span>
                     : mapAddress || "Click on the map to select a location"}
                 </div>
 
                
                 <input
                   type="text"
                   placeholder="Address Title (e.g., Home, Office)"
                   style={{
                     padding: "8px 10px",
                     fontSize: "14px",
                     borderRadius: "6px",
                     border: "1px solid #ccc",
                     width: "100%",
                     boxSizing: "border-box"
                   }}
                   value={addressTitle}
                   onChange={(e) => setAddressTitle(e.target.value)}
                 />
 
              
                 <button
                   style={{
                     padding: "10px 0",
                     fontSize: "16px",
                     borderRadius: "6px",
                     border: "none",
                     background: mapSelectedLocation && mapAddress ? "#ff0054" : "#ccc",
                     color: "#fff",
                     cursor: mapSelectedLocation && mapAddress ? "pointer" : "not-allowed",
                     transition: "0.2s",
                   }}
                   disabled={!mapSelectedLocation || !mapAddress}
                   onClick={handleSaveAddressFromMap}
                   onMouseEnter={(e) => {
                     if (mapSelectedLocation && mapAddress) {
                       e.target.style.background = "#e0004a";
                       e.target.style.transform = "translateY(-2px)";
                     }
                   }}
                   onMouseLeave={(e) => {
                     if (mapSelectedLocation && mapAddress) {
                       e.target.style.background = "#ff0054";
                       e.target.style.transform = "translateY(0)";
                     }
                   }}
                 >
                   Save Address
                 </button>
               </div>
             </div>
           </div>

         
 
           <style>{`
             @keyframes spin {
               0% { transform: rotate(0deg); }
               100% { transform: rotate(360deg); }
             }
           `}</style>
         </div>
       )}
 
       <style>
         {`
           @keyframes spin {
             to { transform: rotate(360deg); }
           }
           .leaflet-container {
             height: 100%;
             width: 100%;
           }
         `}
       </style>
     </div>
   );
 };
 
 export default NavBars;